export default __webpack_public_path__ + "static/media/MagajahalliWaterfalls.0c510aeb.jpg";